import React from 'react';
import SingleTopic from '../SingleTopicChip/SingleTopicChip';
import useMediaQuery from '../../hooks/useMediaQuery';

type TopicChipVariant = 'topic' | 'issue';

interface TopicsContainerProps {
  tags: string[] | undefined;
  variant?: TopicChipVariant;
}

function TopicsContainer({
  tags,
  variant = 'topic'
}: Readonly<TopicsContainerProps>): React.ReactElement {
  const [hideExtraTags, setHideExtraTags] = React.useState<boolean>(true);
  const isTablet = useMediaQuery('(max-width: 767.98px)');

  return (
    <div className='flex flex-row flex-wrap'>
      {tags &&
        tags.map((tag, index) => {
          if (isTablet) {
            if (tags.length > 2 && hideExtraTags) {
              if (index >= 2) return null;
              if (index === 1) {
                const label = `${tags.length - 1} more`;
                return (
                  <SingleTopic
                    key={index}
                    tag={label}
                    isMoreTag
                    variant={variant}
                    setHideExtraTags={setHideExtraTags}
                  />
                );
              }
            }
          } else if (tags.length > 3 && hideExtraTags) {
            if (index >= 3) return null;
            if (index === 2) {
              const label = `${tags.length - 2} more`;
              return (
                <SingleTopic
                  key={index}
                  tag={label}
                  isMoreTag
                  variant={variant}
                  setHideExtraTags={setHideExtraTags}
                />
              );
            }
          }
          return (
            <SingleTopic
              key={index}
              tag={tag}
              isMoreTag={false}
              variant={variant}
              setHideExtraTags={setHideExtraTags}
            />
          );
        })}
    </div>
  );
}

export default TopicsContainer;
